import axios from "axios";

export const axiosInstance = axios.create({
  baseURL: 'https://v6.exchangerate-api.com/v6/',
});

axiosInstance.interceptors.request.use(
  async (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      config.headers.Accept = "Application/json"

    }
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

axiosInstance.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    const RESP = error.response.data;
    if (RESP.error) {
    } else {
    }
    return Promise.reject(error);
  }
);